module.exports = __webpack_public_path__ + "img/delete-reduction-active.09377bf1.svg";